var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, useTheme } from '@mui/material';
import { useHistory } from 'react-router-dom';
import mergeBoxlikeStyles from '../../mergeBoxlikeStyles';
import BusyCircularProgress from '../BusyCircularProgress';
import BusyLinearProgress from '../BusyLinearProgress';
const ButtonEx = (props) => {
    const theme = useTheme();
    const _a = mergeBoxlikeStyles(theme, props), { to, busy, busyVariant = 'linear', busyOpacity, onClick, children } = _a, rootProps = __rest(_a, ["to", "busy", "busyVariant", "busyOpacity", "onClick", "children"]);
    const history = useHistory();
    const localOnClick = (event) => {
        if (!busy) {
            onClick === null || onClick === void 0 ? void 0 : onClick(event);
            if (to) {
                history.push(to);
            }
        }
    };
    return (_jsxs(Button, Object.assign({ onClick: localOnClick }, rootProps, { children: [busy && busyVariant === 'linear' ? _jsx(BusyLinearProgress, { rounded: true, opacity: busyOpacity !== null && busyOpacity !== void 0 ? busyOpacity : 0 }, void 0) : null, busy && busyVariant === 'circular' ? (_jsx(BusyCircularProgress, { rounded: true, size: 24, opacity: busyOpacity !== null && busyOpacity !== void 0 ? busyOpacity : 0.5 }, void 0)) : null, children] }), void 0));
};
export default ButtonEx;
//# sourceMappingURL=ButtonEx.js.map